/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ApplyTo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ApplyTo({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Discounts/Content/Discount/ApplyTo"
  
}) {
let discountIsAppliedToPayorValueData = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'is_applied_to_payor',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnTreatmentFee({
  children,
  viewPath
  
})
let discountIsAppliedToPayorValueData1 = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'is_applied_to_payor',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick1 = fromHelpers.useOnPayorsShare({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="ApplyTo.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Apply to"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 marginLeft={dtSpaceS}
 data="discount.is_applied_to_payor"
 isSelected={!discountIsAppliedToPayorValueData}
 onClick={onClick}
 text="Treatment fee"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 marginLeft={dtSpaceS}
 data="discount.is_applied_to_payor"
 isSelected={discountIsAppliedToPayorValueData1}
 onClick={onClick1}
 marginLeft={dtSpaceXs}
 text="Payor's share"
/>
</div>
{children}
</React.Fragment>)
}